import { Form, FormField } from '@/Core/UI/Form'
import { FormRow, FormSection } from '@/Ship/Components/Form/FormSection'

import { UserNameFields } from '../Components/UserNameFields'
import { UserPhotoField } from '../Components/UserPhotoField'

/**
 * Шаблон редагування профілю користувача
 * Аналогічний до UserEditTemplate, але БЕЗ полів "Ролі" та "Посада".
 * Фото — як у картці співробітника (UserPhotoField): обрізання й фото з iPhone (HEIC),
 * яких стандартне поле file ядра не приймає.
 */
export const UserProfileEditTemplate = ({ formContext }: any) => {
    return (
        <Form formContext={formContext}>
            <FormSection title="Особисті дані">
                <UserPhotoField formContext={formContext} />
            </FormSection>
            <FormSection>
                <UserNameFields formContext={formContext} />
            </FormSection>
            <FormSection>
                <FormRow>
                    <FormField name="phone" />
                    <FormField name="email" />
                </FormRow>
            </FormSection>
        </Form>
    )
}
